export default __webpack_public_path__ + "static/media/menuLogout.6a77d9a2.svg";